import React from "react";
import { Modal } from "react-bootstrap";

interface CouponModalProps {
  onClose: () => void;
  shouldShow: boolean;
  image: any;
}

export default function CouponModal({ onClose, shouldShow, image }: CouponModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Header>
          <h2 className="modal-header-text">Download Coupon</h2>

          <a
            href={image}
            download
            // onClick={onClose}
            target="_blank"
            rel="noreferrer"
            className="download-btn"
          >
            <i className="fa fa-download" aria-hidden="true"></i>
          </a>

          <button type="button" className="btn-close" onClick={onClose}></button>
        </Modal.Header>
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            <img src={image} style={{ width: "100%" }} />
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
